<template>
  <b-sidebar
    id="sidebar-create-letter"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ letter.letter_type ? getLetterType(letter.letter_type).name[$i18n.locale] : null }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="letterCreate">
          <!-- Short info -->
          <b-form-group
            :label="$t('Short Info')"
            label-for="shortInfo"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Short Info')"
              rules="required"
            >
              <b-form-textarea
                id="shortInfo"
                v-model="letter.short_info"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Period -->
          <b-form-group
            :label="$t('Period')"
            label-for="period"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Period')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="letter.period"
                :reduce="(option) => option.id"
                :options="periods"
                :get-option-label="(option) => option.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Period -->
          <b-form-group
            v-if="isTargeted()"
            :label="$t('Organization')"
            label-for="organization"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Organization')"
              rules="required"
            >
              <v-select
                id="organization"
                v-model="letter.to_org"
                :reduce="(option) => option.id"
                :options="organizations"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="letter.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ letter.id ? $t('Update Letter') : $t('Create Letter') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    letter: {
      get() {
        return this.$store.state.letter.letter
      },
      set(data) {
        this.$store.commit('letter/UPDATE', data)
      },
    },
    periods() {
      return this.$store.state.letter.periods
    },
    organizations() {
      return this.$store.state.letter.organizations
    },
  },
  created() {
    this.$store.dispatch('staticModule/letterTypes')
    this.$store.dispatch('letter/organizations')
    localize(this.$i18n.locale)
  },
  methods: {
    isTargeted() {
      return (this.letter.letter_type === this.$store.state.staticModule.letterTypeTargeted)
    },
    loadPeriods() {
      this.$store.dispatch('letter/periods', { status: 'True', step: !this.isTargeted() + 1 })
    },
    getLetterType(id) {
      return this.$store.getters['staticModule/getLetterType'](id)
    },
    clear(hide) {
      this.$store.commit('letter/FRESH')
      this.$refs.letterCreate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.letterCreate.validate().then(success => {
        if (success) {
          this.$confirmCode({
            callback: (confirm, code) => {
              if (confirm) {
                this.$createSwal(this, { ...this.letter, smsCode: code }, `letter/${this.letter.id ? 'update' : 'create'}`, () => {
                  this.$emit('refetchData')
                  this.$store.commit('letter/FRESH')
                })
                hide()
              }
            },
          })
        }
      })
    },
  },
}
</script>
